import { useKey } from 'react-use'

const useGridViewNavigation: (gotoPrev: () => void, gotoNext: () => void) => void = (gotoPrev, gotoNext) =>
  useKey('Tab', ({ shiftKey }) => (shiftKey ? gotoPrev() : gotoNext()))

export default useGridViewNavigation
